// Eine Hauptnavigation (Bereiche) + eine kontextabhaengige Unternavigation (Seiten des Bereichs).
// Desktop/Tablet: Reiter, die umbrechen (nie horizontal scrollen). Smartphone (< 640 px): zwei platzsparende Auswahlmenues.
import THEME from "../../../theme";
import { fs } from "../utils/styles";
import { useBreite, BREAKPOINT_KLEIN } from "./Bausteine";

export default function FinanzNav({ bereiche, route, onWaehle, badges }) {
  const breite = useBreite();
  const aktiv = bereiche.find(b => b.key === route.bereich) || bereiche[0];
  const zahl = (b, s) => (badges?.[`${b}/${s}`] || 0);
  const summe = (b) => b.seiten.reduce((n, s) => n + zahl(b.key, s.key), 0);

  if (breite < BREAKPOINT_KLEIN) {
    return (
      <nav aria-label="Finanzen" style={{ display: "grid", gap: 8, marginBottom: 16 }}>
        <label style={{ ...fs.label, margin: 0 }}>Bereich
          <select aria-label="Bereich" style={{ ...fs.input, width: "100%", marginTop: 4 }} value={aktiv.key} onChange={e => onWaehle(e.target.value, bereiche.find(b => b.key === e.target.value).seiten[0].key)}>
            {bereiche.map(b => <option key={b.key} value={b.key}>{b.label}{summe(b) ? ` (${summe(b)})` : ""}</option>)}
          </select>
        </label>
        {aktiv.seiten.length > 1 && <label style={{ ...fs.label, margin: 0 }}>Seite
          <select aria-label="Seite" style={{ ...fs.input, width: "100%", marginTop: 4 }} value={route.seite} onChange={e => onWaehle(aktiv.key, e.target.value)}>
            {aktiv.seiten.map(s => <option key={s.key} value={s.key}>{s.label}{zahl(aktiv.key, s.key) ? ` (${zahl(aktiv.key, s.key)})` : ""}</option>)}
          </select>
        </label>}
      </nav>
    );
  }
  return (
    <nav aria-label="Finanzen" style={{ marginBottom: 20 }}>
      <div role="tablist" aria-label="Bereiche" style={{ display: "flex", flexWrap: "wrap", gap: 4, borderBottom: `1px solid ${THEME.colors.border}` }}>
        {bereiche.map(b => {
          const ist = b.key === aktiv.key;
          return (
            <button key={b.key} role="tab" aria-selected={ist} onClick={() => onWaehle(b.key, b.seiten[0].key)}
              style={{ background: "transparent", color: ist ? THEME.colors.text : THEME.colors.textSecondary, border: "none", borderBottom: `3px solid ${ist ? THEME.colors.primary : "transparent"}`,
                padding: "10px 16px", fontSize: THEME.fontSize.md, fontWeight: ist ? 700 : 500, cursor: "pointer", marginBottom: -1 }}>
              {b.label}{summe(b) ? <Badge n={summe(b)} /> : null}
            </button>
          );
        })}
      </div>
      {aktiv.seiten.length > 1 && <div role="tablist" aria-label={`Seiten ${aktiv.label}`} style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}>
        {aktiv.seiten.map(s => {
          const ist = s.key === route.seite;
          return (
            <button key={s.key} role="tab" aria-selected={ist} onClick={() => onWaehle(aktiv.key, s.key)}
              style={{ background: ist ? THEME.colors.surfaceMuted : "transparent", color: ist ? THEME.colors.text : THEME.colors.textSecondary, border: `1px solid ${ist ? THEME.colors.primary : THEME.colors.border}`,
                borderRadius: 999, padding: "6px 14px", fontSize: THEME.fontSize.base, cursor: "pointer", fontWeight: ist ? 600 : 400 }}>
              {s.label}{zahl(aktiv.key, s.key) ? <Badge n={zahl(aktiv.key, s.key)} /> : null}
            </button>
          );
        })}
      </div>}
    </nav>
  );
}

function Badge({ n }) {
  return <span style={{ marginLeft: 6, background: THEME.colors.warning, color: "#000", borderRadius: 999, padding: "0 7px", fontSize: THEME.fontSize.xs, fontWeight: 700 }}>{n}</span>;
}
